import { Divider as MuiDivider, styled, DividerProps as MuiDividerProps, css } from '@mui/material';
import { styledOmitCustomProps } from '@braskai/ui-kit';

type TDividerProps = {
  $borderColor?: string;
} & MuiDividerProps;

export const Divider = styled(
  MuiDivider,
  styledOmitCustomProps,
)<TDividerProps>(
  ({ $borderColor, theme }) => css`
    border-color: ${$borderColor || theme.palette.grey[200]};
  `,
);
